import theme from 'src/theme';

const styles = {
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
  },
  cardContainer: {
    justifyContent: 'center',
    display: 'flex',
  },
  card: {
    padding: theme.spacing(2),
    width: '80%',
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: '36px',
    marginBottom: theme.spacing(2),
  },
  descriptionLink: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
  },
  descriptionText: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '0px 24px'
  },
  backToProcysBtn: {
    fontSize: 14,
    fontWeight: 500,
    height: 36,
    minWidth: 108,
    textTransform: 'none',
    backgroundColor: theme.palette.button.cancel,
    color: theme.palette.text.primary,
    paddingTop: 0,
    paddingBottom: 0,
    border: theme.palette.border.cancel,
    margin: '6px 0px 6px 10px'
  },
  saveBtn: {
    fontSize: 14,
    fontWeight: 500,
    height: 36,
    minWidth: 108,
    textTransform: 'none',
    paddingTop: 0,
    paddingBottom: 0,
    margin: '6px 0px 6px 12px',
    backgroundColor: theme.palette.button.action
  },
};

export default styles;
